import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { upperFirst } from 'lodash';
import {
  ModalCard,
  ModalFooter,
  useCreateModal,
} from 'partial/components/Modal';

import Button from 'partial/components/Button';
import { useUpdateActiveMaskName } from '../hooks';

export const useOpenActiveMaskName = () => {
  const createModal = useCreateModal();

  const openActiveMaskNameModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <ActiveMaskName data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openActiveMaskNameModal;
};

function ActiveMaskName({ onClose, data }) {
  const label = data?.is_deactivate ? 'ACTIVATE' : 'DEACTIVATE';
  const [isLoading, update] = useUpdateActiveMaskName(onClose);

  const submit = () => {
    update({
      uuid: data?.uuid,
      payload: { is_deactivate: data?.is_deactivate ? 0 : 1 },
    });
  };

  return (
    <ModalCard
      size="sm"
      title={`${upperFirst(label)} this mask name?`}
      onClose={onClose}
    >
      <div className="px-5 py-4 w-full">
        <p className="text-sm text-neutral-700">
          <span className="font-semibold text-neutral-900">{data?.name}</span>{' '}
          will be {label}d for{' '}
          <span className="font-semibold text-neutral-900">
            {data?.organization_name}
          </span>
          .
        </p>
      </div>
      <ModalFooter>
        <Button secondary onClick={onClose}>
          Cancel
        </Button>
        <Button primary isLoading={isLoading} onClick={submit}>
          {upperFirst(label)}
        </Button>
      </ModalFooter>
    </ModalCard>
  );
}

ActiveMaskName.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ActiveMaskName;
